class BubbleScatterTypeItemVM {
    type: KnockoutObservable<BubbleScatterType>;
    image: KnockoutObservable<string>;
    title: KnockoutObservable<string>;

    constructor(type: BubbleScatterType, title: string) {
        this.type = ko.observable(type);
        this.image = ko.observable(BubbleScatterTypeItemVM.getIcon(type));
        this.title = ko.observable(title);
    }

    static getIcon(type: BubbleScatterType) {
        switch (type) {
            case BubbleScatterType.XAxis:
                return urlConfigs.siteRoot + "Content/Charts/x-axis.svg";
            case BubbleScatterType.YAxis:
                return urlConfigs.siteRoot + "Content/Charts/y-axis.svg";
            case BubbleScatterType.BubbleSize:
                return urlConfigs.siteRoot + "Content/Charts/bubble-size.svg";
        }
    }
}